module.exports = __webpack_public_path__ + "static/fonts/Inter-ExtraLight.909744bb.ttf";